import { useQuery } from "@tanstack/react-query";
import { useAxios } from "@disco/disco_core";

import { FETCH_DASHBOARD_URL } from "../../conf";

const useGetPerformanceDashboards = () => {
	const { apiAxios } = useAxios();

	return useQuery({
		queryKey: [
			"dashboard",
			window.location.hostname?.replace("platform.", ""),
		],
		queryFn: async () => {
			const response = await apiAxios({
				url: `${FETCH_DASHBOARD_URL}?domain=${window.location.hostname?.replace(
					"platform.",
					""
				)}`,
				method: "GET",
			});
			return response.data;
		},
	});
};

export default useGetPerformanceDashboards;
